import script from "./SkillsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsView.vue?vue&type=script&setup=true&lang=js"

import "./SkillsView.vue?vue&type=style&index=0&id=3665cf49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3665cf49"]])

export default __exports__